import firebase, {db, auth, fc, st} from './connection'
import store from '../store.js'

export default {
    getAll() {
        let ref = db.collection('sessions');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    get(id) {
        let ref = db.collection('sessions').doc(id);
    
        return ref.get()
                .then(doc => {
                    return {status: true, doc: doc};
                })
                .catch(error => {
                    return error;
                });
    },

    add(model) {
        let ref = db.collection('sessions');
    
        return ref.add(model)
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

    save(id, model) {
        let ref = db.collection('sessions').doc(id);
    
        return ref.update(model)
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

    uploadFile(session, guid, item, title, materials) {
		let ref = db.collection('sessions').doc(session);
		let uploadTask = st.ref('sessions/' + session + '/' + guid).put(item);

        store.dispatch('setFileUploading', true);
        store.dispatch('setFileUploaded', false);

		uploadTask.on('state_changed', snapshot => {
						let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        store.dispatch('setFileProgress', progress);
					}, error => {
                        console.log(error);
                        store.dispatch('setFileUploading', false);
					}, () => {
                        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
                                materials.push({
                                    name: guid,
                                    url: downloadURL,
                                    title: title
                                });

                                ref.update({materials: materials})
                                    .then( () => {
                                        store.dispatch('setFileUploading', false);
                                        store.dispatch('setFileUploaded', true);
                                    })
                                    .catch( error => {
                                        console.log(error);
                                    });
                            });
					});
    },

    removeFile(model, nameToRemove) {
		let tempo = st.ref('/sessions/' + model.session + '/' + nameToRemove);
		tempo.delete();

		let ref = db.collection('sessions').doc(model.session);

		return ref.update({materials: model.materials})
					.then( () => {
						return true;
					})
					.catch(error => {
						return error;
					});
    },
}